import store from '@/store';

const getTabs = async (orders = []) => {
  const role = store.state.auth?.user?.role;

  const tabs = {};
  if (role === 'client') {
    tabs.active = {
      slug: 'active',
      name: 'Активные',
    };
  } else if (role === 'lab_admin') {
    tabs.new = {
      slug: 'new',
      name: 'Новые',
    };
  }

  if (role !== 'client') {
    tabs.in_progress = {
      slug: 'in_progress',
      name: 'В работе',
    };
  }

  tabs.completed = {
    slug: 'completed',
    name: 'Выполненные',
  };

  if (role !== 'lab_employee') {
    tabs.rejected = {
      slug: 'rejected',
      name: 'Отклоненные',
    };
  }

  // Initialize all tabs
  await Object.keys(tabs).forEach(key => {
    tabs[key].count = 0;
    tabs[key].orders = [];
  });

  // Fill the tabs with data
  await orders.forEach(order => {
    if (role === 'client' && ['new', 'in_progress'].includes(order.status)) {
      tabs.active.count++;
      tabs.active.orders.push(order);
    } else if (order.status in tabs) {
      tabs[order.status].count++;
      tabs[order.status].orders.push(order);
    }
  });

  // For lab_admin and lab_employee, sort the in_progress tab by deadline approaching
  if (role !== 'client') {
    await tabs.in_progress.orders.sort((a, b) => {
      return new Date(a.deadline) - new Date(b.deadline);
    });
  }

  return tabs;
};

export default getTabs;
